export const OPERATOR_TYPE_IS_BLANK = 'OPERATOR_TYPE_IS_BLANK';
export const OPERATOR_TYPE_IS_NOT_BLANK = 'OPERATOR_TYPE_IS_NOT_BLANK';
export const OPERATOR_TYPE_EQUALS = 'OPERATOR_TYPE_EQUALS';
export const OPERATOR_TYPE_NOT_EQUALS = 'OPERATOR_TYPE_NOT_EQUALS';
export const OPERATOR_TYPE_STARTS_WITH = 'OPERATOR_TYPE_STARTS_WITH';
export const OPERATOR_TYPE_DOES_NOT_START_WITH = 'OPERATOR_TYPE_DOES_NOT_START_WITH';
export const OPERATOR_TYPE_ENDS_WITH = 'OPERATOR_TYPE_ENDS_WITH';
export const OPERATOR_TYPE_DOES_NOT_END_WITH = 'OPERATOR_TYPE_DOES_NOT_END_WITH';
export const OPERATOR_TYPE_CONTAINS = 'OPERATOR_TYPE_CONTAINS';
export const OPERATOR_TYPE_DOES_NOT_CONTAIN = 'OPERATOR_TYPE_DOES_NOT_CONTAIN';
export const OPERATOR_TYPE_INCLUDES = 'OPERATOR_TYPE_INCLUDES';
export const OPERATOR_TYPE_DOES_NOT_INCLUDE = 'OPERATOR_TYPE_DOES_NOT_INCLUDE';
export const OPERATOR_TYPE_VALUE_ARE_EMPTY = 'OPERATOR_TYPE_VALUE_ARE_EMPTY';
export const OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY = 'OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY';
export const OPERATOR_TYPE_UNDEFINED = 'OPERATOR_TYPE_UNDEFINED';
export const OPERATOR_TYPE_IS_UNKNOWN = 'OPERATOR_TYPE_IS_UNKNOWN';
export const OPERATOR_TYPE_SHORT_EQUALS = 'OPERATOR_TYPE_SHORT_EQUALS';
export const OPERATOR_TYPE_SHORT_NOT_EQUALS = 'OPERATOR_TYPE_SHORT_NOT_EQUALS';
export const OPERATOR_TYPE_GREATER_THAN = 'OPERATOR_TYPE_GREATER_THAN';
export const OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO = 'OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO';
export const OPERATOR_TYPE_LESS_THAN = 'OPERATOR_TYPE_LESS_THAN';
export const OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO = 'OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO';
export const OPERATOR_TYPE_CURRENT_DATE = 'OPERATOR_TYPE_CURRENT_DATE';
export const OPERATOR_TYPE_WITHIN_PAST_X_DAYS = 'OPERATOR_WITHIN_PAST_X_DAYS';
export const OPERATOR_TYPE_WITHIN_NEXT_X_DAYS = 'OPERATOR_WITHIN_NEXT_X_DAYS';
export const OPERATOR_TYPE_BEFORE_X_DAYS = 'OPERATOR_BEFORE_X_DAYS';
export const OPERATOR_TYPE_AFTER_X_DAYS = 'OPERATOR_AFTER_X_DAYS';
export const OPERATOR_TYPE_ON_OR_AFTER = 'OPERATOR_ON_OR_AFTER';
export const OPERATOR_TYPE_ON_OR_BEFORE = 'OPERATOR_ON_OR_BEFORE';
export const OPERATOR_TYPE_VALUE_EQUALS_TRUE = 'OPERATOR_TYPE_VALUE_EQUALS_TRUE';
export const OPERATOR_TYPE_VALUE_EQUALS_FALSE = 'OPERATOR_TYPE_VALUE_EQUALS_FALSE';
export const OPERATOR_TYPE_SHIPPING_MY_ACCOUNT = 'OPERATOR_TYPE_SHIPPING_MY_ACCOUNT';
export const OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT = 'OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT';
export const OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT = 'OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT';
export const OPERATOR_TYPE_TIME_AT_OR_AFTER = 'OPERATOR_TYPE_TIME_AT_OR_AFTER';
export const OPERATOR_TYPE_TIME_AT_OR_BEFORE = 'OPERATOR_TYPE_TIME_AT_OR_BEFORE';
